<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>分类参数</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图 -->
    <el-card>
      <el-alert show-icon :closable="false" title="注意：只允许为第三级分类设置相关参数" type="warning"></el-alert>
      <el-row>
        <el-col class="cat_opt">
          <span>请选择商品分类：</span>
          <span>
            <el-cascader
              v-model="selectedKey"
              :options="catList"
              :props="{ value:'cat_id', label:'cat_name', children:'children' }"
              @change="cateChanged"
            ></el-cascader>
          </span>
        </el-col>
      </el-row>

      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="动态参数" name="many">
          <el-button type="primary" size="mini" :disabled="isBtnDisabled" @click="addDialogVisible  = true">添加参数</el-button>
          <el-table :data="manyTableData" border stripe>
            <el-table-column type="index"></el-table-column>
            <el-table-column label="参数名称" prop="attr_name"></el-table-column>
            <el-table-column label="操作" width="200px">
              <template>
                <el-button type="primary" icon="el-icon-edit" size="mini">编辑</el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="静态属性" name="only">
          <el-button type="primary" size="mini" :disabled="isBtnDisabled" @click="addDialogVisible  = true">添加属性</el-button>
          <el-table :data="onlytableData" border stripe>
            <el-table-column type="index"></el-table-column>
            <el-table-column label="属性名称" prop="attr_name"></el-table-column>
            <el-table-column label="操作" width="200px">
              <template>
                <el-button type="primary" icon="el-icon-edit" size="mini">编辑</el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-dialog :title="'添加' + dialogTitle" :visible.sync="addDialogVisible" width="50%" @close="addDialogClose">
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px">
        <el-form-item :label="dialogTitle " prop="attr_name">
          <el-input v-model="addForm.attr_name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  created () {
    this.getCatList()
  },
  data () {
    return {
      catList: [],
      selectedKey: [],
      activeName: 'many',
      manyTableData: [],
      onlytableData: [],
      addDialogVisible: false,
      addForm: {
        attr_name: ''
      },
      addFormRules: []
    }
  },
  methods: {
    // 查询分类列表
    async getCatList () {
      const { data: res } = await this.$http.get('categories')
      if (res.meta.status !== 200) return this.$message.err(this.meta.msg)
      this.catList = res.data
    },
    cateChanged () {
      this.getCateData()
    },
    handleTabClick () {
      this.getCateData()
    },
    async getCateData () {
      if (this.selectedKey.length !== 3) {
        this.selectedKey = []
        return false
      }
      // console.log(this.selectedKey)
      const { data: res } = await this.$http.get(
        `categories/${this.cateId}/attributes`,
        {
          params: { sel: this.activeName }
        }
      )
      if (res.meta.status !== 200) {
        return this.$message.error('获取参数列表失败')
      }
      if (this.activeName === 'many') {
        this.manyTableData = res.data
      } else {
        this.onlytableData = res.data
      }
    },
    addDialogClose () {

    }
  },
  computed: {
    isBtnDisabled () {
      if (this.selectedKey.length !== 3) {
        return true
      } else {
        return false
      }
    },
    cateId () {
      if (this.selectedKey.length !== 3) {
        return null
      } else {
        return this.selectedKey[2]
      }
    },
    dialogTitle () {
      if (this.activeName === 'many') {
        return '动态参数'
      } else {
        return '静态属性'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.cat_opt {
  margin-top: 15px;
  margin-bottom: 15px;
}

</style>
